// extracted by mini-css-extract-plugin
module.exports = {"heading":"card-module--heading--1U1Mp","cardContainer":"card-module--cardContainer--tgyZg","portraitCardContainer":"card-module--portraitCardContainer--yMoj7"};